import { mergeAttributes, Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import InlineImageEditorComponent from './InlineImageEditorComponent.jsx'

export default Node.create({
  name: 'custom-img',
  atom: true,
  group: 'block',
  inline: false,
  selectable: true,
  addOptions() {
    return {
      inline: false,
      HTMLAttributes: {},
    }
  },
  draggable: true,
  addAttributes() {
    return {
      fileId: {
        default: null,
      },
      entityType: {
        default: null,
      },
      entityId: {
        default: null,
      },
      file: {
        default: null,
      },
    }
  },
  addCommands() {
    return {
      setCustomImage: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        });
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'custom-img',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ['custom-img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
  },
  addNodeView() {
    return ReactNodeViewRenderer(InlineImageEditorComponent)
  },
});
